<template>
  <div class="jumbotron-component">
    <section class="hero is-medium -bg">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-reverse">
            <div
              class="column is-7 has-text-centered-mobile has-padding-top-20"
              v-anime="{
                translateX: [-1000, 0],
                duration: 500,
                easing: 'easeInOutCirc',
                delay: 200
              }"
            >
              <br />
              <h2
                class="title is-size-2 is-size-3-touch has-text-centered-mobile"
              >
                Serverless Synchronized Video
              </h2>
              <p class="subtitle">You build experiences. We'll do the rest.</p>
              <router-link to="/how-it-works">
                <b-button
                  size="is-medium"
                  type="is-primary"
                  v-anime="{
                    scale: [1, 1.2, 1],
                    duration: 700,
                    delay: 400,
                    easing: 'easeInOutSine'
                  }"
                  >Learn More</b-button
                >
              </router-link>
            </div>
            <div
              class="column is-5 has-text-centered -bg-sizing-fix"
              v-anime="{
                translateX: [1000, 0],
                duration: 300,
                easing: 'easeInOutCirc',
                delay: 500
              }"
            >
              <img
                class="-illustration"
                src="@/assets/img/illustrations/02.png"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "JumbotronComponent"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.-illustration {
  max-height: 300px;
  padding: 25px;
  width: auto;
  margin: 0 auto;
}

.-bg {
  background: url("../../assets/img/bg/standard/01.svg");
  background-position: 80% 98%;
  background-repeat: none;
  background-size: cover;
}

@media only screen and (max-width: 600px) {
  .-illustration {
    max-height: 200px;
    padding: 5px;
    width: auto;
  }
  .-bg {
    background: url("../../assets/img/bg/standard/02.svg");
    background-position: 50% 20%;
  }
}
</style>
